<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="where" label-width="90px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="国家/地区">
              <el-input clearable v-model.trim="where.country" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="国家编码">
              <el-input clearable v-model.trim="where.country_code" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="币种名称">
              <el-input clearable v-model.trim="where.name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="币种代码">
              <el-input clearable v-model.trim="where.code" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)">添加</el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon"
            :disabled="!selection.length" @click="removeBatch">删除</el-button>
        </template>
        <template slot="status" slot-scope="{ row }">
          <dict-tag dict-code="switch_status" :value="row.status" />
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)">编辑</el-button>
          <el-popconfirm class="ele-action" title="确定要删除此法币吗？" @confirm="remove(row)">
            <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </ele-pro-table>
    </el-card>
    <fiatcurrency-edit :data="current" :visible.sync="showEdit" @done="reload" />
  </div>
</template>

<script>
import FiatcurrencyEdit from './fiatcurrency-edit';

export default {
  name: 'WalletFiatCurrency',
  components: { FiatcurrencyEdit },
  data() {
    return {
      url: '/FiatCurrency/index',
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        { prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { prop: 'country', label: '国家/地区', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'country_code', label: '国家编码', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'name', label: '币种名称', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'code', label: '币种代码', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'sort', label: '排序', width: 80, align: 'center' },
        { prop: 'status', label: '状态', width: 90, align: 'center', slot: 'status' },
        { columnKey: 'action', label: '操作', width: 150, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: {},
      selection: [],
      current: null,
      showEdit: false
    };
  },
  methods: {
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/FiatCurrency/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的法币吗?', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/FiatCurrency/delete', { id: this.selection.map((d) => d.id) }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    }
  }
};
</script>
